import React from "react";
import InfoIcon from "@material-ui/icons/Info";
import { formatDateHour } from "shared/utils";
import dayjs from "dayjs";
import { utc } from "dayjs";
import { CustomTooltip } from "components/CustomTooltip";
import { useTranslations } from "adapters/i18n";

dayjs.extend(utc);

const calcDiffSincronization = (createdAt, operationDate) => {
  return dayjs(createdAt).diff(operationDate, "hours");
};

const SynchronizationTimeCell = ({ row, classes }) => {
  const { t } = useTranslations();
  const isMoreThan12H =
    calcDiffSincronization(row.createdAt, row.operationDate) >= 12;
  return (
    <div>
      {isMoreThan12H && (
        <CustomTooltip
          title={CONTENT_TOOLTIP}
          className={classes.tooltip}
          classes={{
            tooltip: classes.tooltipContent,
          }}
        >
          <InfoIcon />
        </CustomTooltip>
      )}

      {formatDateHour(dayjs.utc(row.createdAt))}
    </div>
  );
};

export default SynchronizationTimeCell;
